// @ts-nocheck

import produce from 'immer'
import { Reducer } from 'redux'
import { User, UserActions } from './types'
import history from 'routes/services/history'

const INITIAL_STATE: User = {
  id: '',
  userId: '',
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  createdAt: '',
  updatedAt: '',
  document: '',
  cashBackBalanceCents: 0,
  isAuthenticated: false,
  loading: false
}

export const UserReducer: Reducer<User> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UserActions.setUser:
      return produce(state, (draft) => {
        draft.loading = false
        draft.isAuthenticated = true
        draft.id = action.payload.id
        draft.userId = action.payload.userId
        draft.firstName = action.payload.firstName
        draft.document = action.payload.document
        draft.lastName = action.payload.lastName
        draft.email = action.payload.email
        draft.phone = action.payload.phone
        draft.cashBackBalanceCents = action.payload.cashBackBalanceCents
        if (action.payload.address) {
          draft.address = {
            number: action.payload.address.number,
            state: action.payload.address.state,
            country: action.payload.address.country,
            city: action.payload.address.city,
            street: action.payload.address.street,
            complement: action.payload.address.complement,
            zipCode: action.payload.address.zipCode
          }
        }

        if (action.payload.accessToken && action.payload.refreshToken) {
          draft.accessToken = action.payload.accessToken
          draft.refreshToken = action.payload.refreshToken
        }
      })
    case UserActions.editUserSuccess:
      return produce(state, (draft) => {
        draft.firstName = action.payload.firstName
        draft.lastName = action.payload.lastName
        draft.email = action.payload.email
        draft.phone = action.payload.phone
        draft.address = action.payload.address
      })
    case UserActions.refreshToken:
      return produce(state, (draft) => {
        draft.accessToken = action.payload.accessToken
        draft.refreshToken = action.payload.refreshToken
      })
    case UserActions.addLocation:
      return produce(state, (draft) => {
        const payload = action.payload
        if (typeof payload === 'string') {
          if (payload) {
            draft.location = { city: payload }
          }
          return
        }
        const nextLocation = {
          ...(payload?.state ? { state: payload.state } : {}),
          ...(payload?.city ? { city: payload.city } : {})
        }
        if (nextLocation.state || nextLocation.city) {
          draft.location = nextLocation
        }
      })
    case UserActions.clearLocation:
      return produce(state, (draft) => {
        delete draft.location
      })
    case UserActions.authenticationRequest:
      return produce(state, (draft) => {
        draft.loading = true
      })
    case UserActions.authenticationFailed:
      return produce(state, (draft) => {
        draft.isAuthenticated = false
      })
    case UserActions.logout:
      // eslint-disable-next-line prettier/prettier
      document.cookie = `applaus-auth-customer=; path=/; domain=${process.env.REACT_APP_DOMAIN}; expires=${new Date(0).toUTCString()}`;
      if (window.matchMedia('(display-mode: standalone)').matches) {
        history.push('/')
      }
      return {
        ...INITIAL_STATE,
        ...(state.location ? { location: state.location } : {})
      }
    default:
      return state
  }
}
